<i18n lang='yml' src='../i18n/TrainingProgramForm.yml'></i18n>
<template>
  <div>
    <flash :message_type="message_type" :message_text="message_text"/>
    <Form ref="observer" v-slot="{ errors }" @submit="submitUserInput" @invalid-submit="setErrorMessage">
      <!-- <form > -->
        <fieldset class="form-group border-bottom">
          <legend>
            {{$t('details')}}
          </legend>
          <div class="form-group row">
            <div class="col-md-12">
              <Field 
                :name="$t('trade_code.label')"  
                rules="required" 
                v-slot="{ errors, field }"
                v-model="trainingProgram.trade_code">
                <label :for="$t('trade_code.label')"> 
                  {{$t('trade_code.label')}} 
                </label>
                <span class="red">*</span>
                <input :id="$t('trade_code.label')" 
                  name="trade_code"
                  class="form-control" 
                  :class="{'is-invalid': errors[0]}" 
                  v-bind="field"
                  type="text">
                <div class="invalid-feedback" id="trade_code_error" v-if="errors[0]">
                  <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                  <span> {{ errors[0] }} </span>
                </div>
              </Field>
            </div>         
          </div>    
         
          <div class="form-group row">
            <div class="col-md-12">
              <Field 
                :name="$t('name_en.label')"
                rules="required" 
                v-slot="{ errors, field }"
                v-model="trainingProgram.name.en">
                <label :for="$t('name_en.label')"> 
                  {{$t('name_en.label')}} 
                </label>
                <span class="red">*</span>
                <input :id="$t('name_en.label')" 
                  name="name_en"
                  class="form-control" 
                  :class="{'is-invalid': errors[0]}" 
                  v-bind="field"
                  type="text">
                <div class="invalid-feedback" id="name_en_error" v-if="errors[0]">
                  <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                  <span> {{ errors[0] }} </span>
                </div>
              </Field>   
            </div>
          </div>

          <div class="form-group row">
            <div class="col-md-12">
              <Field 
                :name="$t('name_fr.label')"  
                rules="required" 
                v-slot="{ errors, field }"
                v-model="trainingProgram.name.fr">
                <label :for="$t('name_fr.label')"> 
                  {{$t('name_fr.label')}} 
                </label>
                <span class="red">*</span>
                <input :id="$t('name_fr.label')" 
                name="name_fr"
                class="form-control" 
                :class="{'is-invalid': errors[0]}" 
                v-bind="field"
                type="text">
                <div class="invalid-feedback" id="name_fr_error" v-if="errors[0]">
                  <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                  <span> {{ errors[0] }} </span>
                </div>
              </Field>   
            </div>
          </div>
         
         
        </fieldset>
        <div v-if="Object.keys(errors).length > 0 && showErrorBanner" class="alert alert-danger" role="alert">
            <span class="red mr-2">
              <font-awesome-icon :icon="['far', 'exclamation-circle']"/>
            </span>
            {{ $t('error_warning') }}
          </div>
        
        <div class="btn-row d-flex">
          <button type="submit" class="btn btn-primary btn-success no-shadow" v-if="type=='new'">
            <font-awesome-icon :icon="['fa', 'save']" />
            {{ $t('create') }}
          </button>
          <template v-else>
            <button  type="submit" class="btn btn-primary btn-success no-shadow">
              <font-awesome-icon :icon="['fa', 'save']" />
              {{ $t('submit') }}
            </button>
            <a class="btn btn-danger" :data-confirm="$t('confirm_delete')" data-method="delete" :href="load_path">
              <font-awesome-icon :icon="['fa', 'trash-alt']" />
              {{ $t('delete_program') }}
            </a>
          </template>
            <a class="btn btn-light ml-auto" :href="cancel_path">
            <font-awesome-icon :icon="['fa', 'times']" />
            {{ $t('cancel') }}
          </a>
        </div>
      </Form>
    </div>
</template>
<script>
    import flash from '../../../../shared/flash_messages/components/Flash.vue';
    import '../../../../../javascripts/application/vee-validate-rules.js';
    import { sendAjaxRequest, ajaxResponseMessage } from '../../../../shared/typescripts/ajax.ts'
    import { setErrorMessage } from '../../../../shared/typescripts/error.ts'
 
    import { Form, Field } from 'vee-validate'
    export default {
      components: { flash, Form, Field },

      props: {
        locale: String,
        training_program: String,
        load_path: String,
        cancel_path: String,
        type: String
      },

      data(){
        return{
          trainingProgram: {name: {}},
          message_text: [],
          message_type: "",
          responses: [],
          errors: {},
          showErrorBanner: false,
        };
      },
      created(){
        this.$i18n.locale = this.locale;        
      },
      mounted() {
        try {
          this.trainingProgram = JSON.parse(this.training_program)
          if(this.trainingProgram.name == null){
            this.trainingProgram.name = {}
          }
        }
        catch(err) {
          this.error = true; 
        } 
      },

      methods: {
        setErrorMessage({ valuese, errors, results }) {
          setErrorMessage(this, errors, true)
        },
        
        submitUserInput(event){
          let payload = []
          payload = { training_program: this.trainingProgram }
          this.message_text = [];
          let send_type =  this.type == "edit" ? "PUT" : "POST"

          sendAjaxRequest(send_type, this.load_path, 'json', payload, ajaxResponseMessage, this.throwError);
        },

        throwError() {
          console.log("Error")
        }
      }, 
    }
</script>
